var map = {
	"./de.json": 886636,
	"./en.json": 284675,
	"./es.json": 23733,
	"./fr.json": 544827,
	"./it.json": 453287,
	"./ja.json": 159153,
	"./ko.json": 993633,
	"./pl.json": 985075,
	"./pt.json": 170613,
	"./ru.json": 35580,
	"./uk.json": 450112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 742501;